"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractSmartcontractFacade = void 0;
class AbstractSmartcontractFacade {
    constructor(contractAddress, chainId, providerConnector) {
        this.contractAddress = contractAddress;
        this.chainId = chainId;
        this.providerConnector = providerConnector;
    }
    getContractCallData(methodName, methodParams = []) {
        return this.providerConnector.contractEncodeABI(this.ABI, this.contractAddress, methodName, methodParams);
    }
}
exports.AbstractSmartcontractFacade = AbstractSmartcontractFacade;
//# sourceMappingURL=abstract-facade.js.map